import { deserialize } from 'deserialize-json-api'

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

const sanitizeJsonApiDocument = (document) => {
  if (!isObject(document)) return document

  if (!Array.isArray(document.included)) document.included = []

  if (Array.isArray(document.data)) {
    document.data = document.data.filter(Boolean)
    document.data.forEach(sanitizeJsonApiResource)
  } else if (isObject(document.data)) {
    sanitizeJsonApiResource(document.data)
  }

  if (Array.isArray(document.included)) {
    document.included = document.included.filter(Boolean)
    document.included.forEach(sanitizeJsonApiResource)
  }

  return document
}

const sanitizeJsonApiResource = (resource) => {
  if (!isObject(resource)) return
  const relationships = resource.relationships
  if (!isObject(relationships)) return

  Object.keys(relationships).forEach((key) => {
    const relationship = relationships[key]
    if (!isObject(relationship) || !('data' in relationship)) return

    const data = relationship.data
    if (data === null) {
      delete relationships[key]
      return
    }
    if (Array.isArray(data)) {
      relationship.data = data.filter(
        (rel) => isObject(rel) && typeof rel.type === 'string' && typeof rel.id === 'string'
      )
    }
  })
}

export default async (axios, resource, params) => {
  const response = await axios.get(resource, { params })
  sanitizeJsonApiDocument(response.data)
  const data = deserialize(response.data)
  return data
}
